<template>
  <el-dialog :title="`${$t('specialOffer')} > ${$t('agentList')}`" :visible="isShowDialog" @close="onClosePopupButtonClick()" width="700px">
    <el-container>
      <el-main>
        <el-form ref="form">
          <el-form-item>
            <el-col :span="4" >
              <label class="label-popup">{{$t('refCode')}}:</label>
            </el-col>
            <el-col :span="20">
              <span class="border-special-offer-ref-code">{{refCode}}/<span class="helping-tag" style="margin-left: 3px; text-transform: uppercase">{{$t('agentName')}}</span></span>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="4" class="font-bold">
              <label class="label-popup">{{$t('promotion')}}:</label>
            </el-col>
            <el-col :span="20">
              <span class="promotion-code-tag">{{promotionCode}}</span>
            </el-col>
          </el-form-item>
        </el-form>
        <div style="margin-top: 35px" v-loading="isLoading">
          <div style="margin-bottom: 10px">
            <el-input type="text"
                      size="small"
                      v-model="keyword"
                      @input="isTyping = true"
                      placeholder="Filter by name">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>

          <table class="table-apply-room-type" border="0" cellspacing="0" cellpadding="0">
            <tr class="table-apply-room-type-header">
              <td width="40%">{{$t('agentName')}}</td>
              <td width="60%"></td>
            </tr>
            <template v-for="(agent, index) of getAgentListDataSource()">
              <tr class="table-apply-room-type-body" :key="`agent-${index}`"
                  :class="getClassRowDisable(agent.id)">
                <td width="40%">
                  {{agent.name}}
                </td>
                <td width="60%">
                  <div style="text-align: right; white-space: nowrap;">
                    <el-badge
                      v-if="getTotalSignedDocument(agent) > 0"
                      :value="getTotalSignedDocument(agent)" class="item" type="primary">
                      <div style="padding: 5px 5px; border: solid 0px #b3d8ff; border-radius: 3px; background: #ecf5ff; cursor: pointer"
                        @click="agent.isExpandSignedDocumentList = !agent.isExpandSignedDocumentList">
                        <div class="signed-document-primary"
                             style="float: left; margin-top: 2px"
                        ></div>
                        <i style="color: #409EFF" :class="{'el-icon-caret-bottom': !agent.isExpandSignedDocumentList,'el-icon-caret-top': agent.isExpandSignedDocumentList}"></i>
                      </div>
                    </el-badge>
                    &nbsp;
                    <el-button
                      style="border-radius: 4px 0 0 4px; padding: 10px 20px; font-size: 12px; margin-left: 10px"
                      type="primary"
                      @click="onDownloadButtonClick(agent)"
                    >
                      {{ $t('download') }}
                    </el-button>
                    <el-dropdown>
                      <el-button type="primary" split-button style="padding: 10px 5px 10px 0; border-radius: 0 4px 4px 0; margin-left: -1px; font-size: 12px">
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" class="action-list">
                        <el-dropdown-item @click.native="onPreviewButtonClick(agent)">
                          {{ $t('preview') }}
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="onSendEmailButtonClick(agent)">
                          {{ $t('email') }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </td>
              </tr>
              <tr :key="`signed-doc-${index}`" v-if="agent.isExpandSignedDocumentList === true">
                <td colspan="2" style="padding-left: 30px; padding-bottom: 20px">
                  <div style="font-weight: 600; font-size: 14px; margin-bottom: 10px">
                    {{$t('signedDocument')}}
                  </div>
                  <el-row v-for="(signedDocument, index) in agent.signedDocumentList"
                          :key="`signedDocument-${index}`">
                    <el-col :span="16">
                      <div class="signed-document-default"
                           style="float: left; margin-top: 5px; margin-right: 5px;"></div>
                      <div
                        :class="{'latest-file': (index === 0)}"
                        style="float: left">
                        {{ getDocumentName(signedDocument.name) }}
                      </div>
                    </el-col>
                    <el-col :span="4"
                            style="text-align: right; padding-right: 15px"
                            :class="{'latest-file': (index === 0)}">
                      {{getCreatedAt(signedDocument.createdAt)}}
                    </el-col>
                    <el-col :span="4">
                      <el-button type="primary"
                                 plain
                                 size="mini"
                                 @click="onDownloadSignedDocumentButtonClick(signedDocument)">
                        {{$t('download')}}
                      </el-button>
                    </el-col>
                  </el-row>
                </td>
              </tr>
            </template>
            <tr v-if="getAgentListDataSource().length === 0"
                class="table-apply-room-type-body">
              <td colspan="4" align="center" style="font-style: italic; color: #cfc4cf">{{ $t('noData') }}</td>
            </tr>
          </table>
          <div style="margin-top: 10px">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="filterData().length"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change = "changePage">
            </el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-dialog>
</template>

<script>
import i18nMessages from '@/translations/SpecialOffer/components/PopupSpecialOfferAgentListComponent.i18n'
import { debounce, get, cloneDeep, setWith } from 'lodash'
import { sortDataList, forceDownloadFileUrl } from '@/helpers'
import { filterDataByKeyword, getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import SpecialOfferApi from '@/api/special-offer-api'
import { dateFormat } from '@/helpers/datetime'

export default {
  name: 'PopupSpecialOfferAgentListComponent',
  i18n: { messages: i18nMessages },
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    refCode: {
      type: String,
      default: ''
    },
    promotionCode: {
      type: String,
      default: ''
    },
    specialOfferId: {
      type: String,
      default: ''
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isShowDialog: false,
      currentPage: 1,
      pageSize: 5,
      sortKey: 'name',
      sortBy: 'ascending',
      isTyping: false,
      keyword: '',
      filteredAgentList: [],
      sortedAgentList: [],
      isLoading: true,
      agentListById: {}
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
      if (newValue === true && this.specialOfferId !== '') {
        this.initData()
      }
    },
    keyword: debounce(function () {
      this.isTyping = false
    }, 300),
    isTyping: function (value) {
      if (!value) {
        this.getAgentListDataSource()
      }
    }
  },
  methods: {
    initData: async function () {
      this.isLoading = true
      try {
        const result = await SpecialOfferApi.detail(this.specialOfferId)
        const agentList = cloneDeep(get(result.specialOfferDetail, 'agentList', []))
        const applyExpandSignedDocumentListStatus = (agent) => {
          return setWith(agent, 'isExpandSignedDocumentList', false, Object)
        }
        const newAgentList = agentList.map((item) => applyExpandSignedDocumentListStatus(item))
        this.sortedAgentList = sortDataList(newAgentList, this.sortKey, this.sortBy)
        this.getAgentListDataSource()
      } catch (err) {
        this.alertError(err.message)
      }
      this.isLoading = false
    },
    getAgentListDataSource: function () {
      const filteredList = this.filterData()
      this.currentPage = adjustCurrentPage(filteredList.length, this.currentPage, this.pageSize)

      const resultList = getDataOnPaging(filteredList, this.currentPage, this.pageSize)
      return resultList
    },
    filterData: function () {
      const searchKeys = ['name']
      const filteredList = filterDataByKeyword(this.sortedAgentList, this.keyword, searchKeys)

      return filteredList
    },
    changePage: function (page) {
      this.currentPage = page
    },
    getClassRowDisable: function (id) {
      const agent = this.agentList.find((item) => item.id === id)
      if (agent.isEnable === 1) {
        return ''
      }
      return 'row-disabled'
    },
    getRowClassName: function ({ row, rowIndex }) {
      if (row.isEnable === 1) {
        return ''
      }
      return 'disable-row'
    },
    onClosePopupButtonClick: function () {
      this._closePopup()
    },

    onPreviewButtonClick: function (agent) {
      this.$emit('onPreview', agent.id)
    },
    onDownloadButtonClick: function (agent) {
      this.$emit('onDownload', agent.id)
    },
    onSendEmailButtonClick: function (agent) {
      this.$emit('onSendEmail', agent.id)
    },
    getCreatedAt: function (unixTime) {
      const createdAt = new Date(unixTime * 1000)

      return dateFormat.short(createdAt)
    },
    onDownloadSignedDocumentButtonClick: async function (signedDocument) {
      this.startLoading()

      try {
        const data = {
          fileUrl: signedDocument.url
        }
        const documentResult = await SpecialOfferApi.downloadSignedDocument(data)
        const documentData = `data:${signedDocument.mimeType}; base64, ${documentResult}`
        forceDownloadFileUrl(documentData, signedDocument.name)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    getTotalSignedDocument: function (agent) {
      const signedDocumentList = get(agent, 'signedDocumentList', [])

      return signedDocumentList.length
    },
    getDocumentName: function (name) {
      if (name.length > 50) {
        return `${name.substring(0, 46)}...`
      }

      return name
    },
    _closePopup: function () {
      this.keyword = ''
      this.isShowDialog = false
      this.$emit('onClose')
    }
  }
}
</script>

<style scoped>
  .border-special-offer-ref-code {
    background-color: #ecf5ff;
    color: #2f7dfe;
    padding: 10px 10px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 40px;
    position: relative;
    font-size: 14px;
  }

  .helping-tag {
    background-color: #2f7dfe;
    color: #ffffff;
    padding: 3px 5px;
    border-radius: 15px;
    font-size: 10px;
    vertical-align: bottom;
  }

  .promotion-code-tag {
    border: 2px solid #dddddd;
    padding: 8px 10px;
    border-radius: 5px;
    color: #409EFF;
  }

  .label-popup {
    padding-right: 10px;
    font-weight: 600;
  }

  .el-dropdown-menu {
    padding: 0;
  }
  .action-list .el-dropdown-menu__item.text-error {
    color: #F56C6C;
  }
  .action-list .el-dropdown-menu__item {
    border-bottom: 1px #fff solid;
    padding: 0 70px 0 20px;
  }
  .action-list .el-dropdown-menu__item:last-of-type {
    border-bottom: 0;
  }

  .table-apply-room-type {
    width: 100%;
    margin-bottom: 22px;
    border-bottom: 1px #ddd solid;
  }

  .table-apply-room-type-header td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    color: #2476e4;
    background-color: #eeeeee;
    font-size: 14px;
    font-weight: 500;
  }

  .table-apply-room-type-body td {
    padding: 10px;
    border-top: 1px #ddd solid;
    font-size: 14px;
  }
  .row-disabled {
    background-color: #eeeeee !important;
    color: #bababa;
  }
  .el-row {
    margin-bottom: 10px;
  }
  .el-row:last-child {
     margin-bottom: 0;
   }
  .latest-file {
    font-weight: 600;
  }
</style>
